export class AddContract {
  public SerialNumber: string;
  public RegistrationNumber: string;
  public ContractNumber: string;
  public Password: string;
  public ConfirmPassword: string;
}



// WEBPACK FOOTER //
// ./src/app/models/AddContract.ts